/**
 * Resets the cart drawer's scroll position to the top every time it opens.
 * Fixes an intermittent bug where reopening the drawer (especially after
 * removing/re-adding items) showed the footer flush at the top with the
 * header and item rows scrolled out of view above it — a leftover
 * scrollTop on the panel or its item list, not something a CSS overflow
 * fix alone reliably prevents (Dawn's own component-cart-drawer.css has a
 * short-viewport rule that can re-enable whole-panel scrolling; even with
 * that neutralized, this is a more direct guarantee than depending on
 * exactly which CSS rule wins). <cart-drawer> itself persists across cart
 * updates (only its #CartDrawer child's innerHTML gets replaced by
 * renderContents), so a single observer set up once on load keeps working
 * for every subsequent open.
 */
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function resetScroll() {
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.scrollTop = 0;
    const items = drawer.querySelector('cart-drawer-items');
    if (items) items.scrollTop = 0;
  }

  const observer = new MutationObserver(() => {
    if (drawer.classList.contains('active')) resetScroll();
  });
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
});
